import { Injectable } from '@angular/core';

import { AzavistaApiService, ISearchIntegrationsRequest, IUserMessageLogItem } from '@azavista/servicelib';
import { IField } from '@azavista/components/shared';
import { SharedService } from 'src/app/shared/shared.service';
import { TranslationKey } from '../enums';

@Injectable({
    providedIn: 'root'
})
export class RecipientMessagesService {
    private integrationFieldId = 'integration_id';
    private createdAtFieldId = 'created_at';

    constructor(private sharedSvc: SharedService, private apiSvc: AzavistaApiService) {
    }

    async setIntegrationNames(messages: IUserMessageLogItem[]): Promise<void> {
        const messagesIds = messages.filter(x => !!x.integration_id).map(x => x.integration_id);
        const distinctIntegrationIds = this.sharedSvc.getDistinctArray(messagesIds, x => x);
        if (distinctIntegrationIds.length === 0) {
            return;
        }
        const req: ISearchIntegrationsRequest = {
            limit: 50, offset: 0, advancedQuery: this.sharedSvc.createIdInSearchParams(distinctIntegrationIds)
        };
        const integrationsRes = await this.apiSvc.getIntegrationsList(req);
        for (const message of messages) {
            const integration = integrationsRes.integrations.find(x => x.id === message.integration_id);
            if (integration) {
                message[this.integrationFieldId] = integration.name;
            }
        }
    }

    getColumns(): IField[] {
        const result: IField[] = [
            {
                id: this.integrationFieldId, name: this.integrationFieldId, schema: { type: 'string' },
                label: this.sharedSvc.translate(TranslationKey.integration)
            },
            {
                id: 'body', name: 'body', schema: { type: 'string' },
                label: this.sharedSvc.translate(TranslationKey.body)
            },
            {
                id: 'status', name: 'status', schema: { type: 'string' },
                label: this.sharedSvc.translate(TranslationKey.status)
            },
            {
                id: 'error', name: 'error', schema: { type: 'string' },
                label: this.sharedSvc.translate(TranslationKey.error)
            },
            {
                id: this.createdAtFieldId, name: this.createdAtFieldId, schema: { type: 'string', format: 'date-time' },
                label: this.sharedSvc.translate(TranslationKey.createdAt)
            },
            {
                id: 'sent_at', name: 'sent_at', schema: { type: 'string', format: 'date-time' },
                label: this.sharedSvc.translate(TranslationKey.sentAt)
            }
        ] as IField[];
        return result;
    }

    getDisplayedColumns(columns: IField[]): string[] {
        return columns.map(x => x.id);
    }

    getCreatedAtField(fields: IField[]): IField {
        return fields.find(x => x.id === this.createdAtFieldId);
    }
}
